import Alpine from 'alpinejs';

Alpine.store('header', {
    isScrolled: false,
    mobileNavOpen: false,
    subnavOpen: false,
    subnavScrolled: false,
    isVisible: true,
    lastScrollY: 0,
    scrollThreshold: 5,

    toggleMobileNav() {
        this.mobileNavOpen = !this.mobileNavOpen;
    },

    handleScroll() {
        const currentScrollY = window.scrollY;
        const scrollDelta = currentScrollY - this.lastScrollY;

        // Update isScrolled state
        this.isScrolled = currentScrollY > 0;

        // Always show header at top of page
        if (currentScrollY <= 0) {
            this.isVisible = true;
            this.lastScrollY = currentScrollY;
            return;
        }

        // Only update visibility if scroll delta exceeds threshold
        if (Math.abs(scrollDelta) < this.scrollThreshold) {
            return;
        }

        // Scrolling down - hide header
        if (scrollDelta > 0 && currentScrollY > 100) {
            this.isVisible = false;
        }
        // Scrolling up - show header
        else if (scrollDelta < 0) {
            this.isVisible = true;
        }

        this.lastScrollY = currentScrollY;
    }
});
